import React, {StrictMode} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BtnPlaylist, IconHeader} from "react-commons-moodle";


// alternative to DOMContentLoaded
document.onreadystatechange = function () {
    if (document.readyState == "interactive") {
        console.log("card: ", document.getElementsByName('btn-playlist'));
        document.getElementsByName('btn-playlist').forEach(d => {
            console.log(d.getAttribute('courseId'));
            ReactDOM.render(<BtnPlaylist isCourse={d.getAttribute('isCourse')} courseId={d.getAttribute('courseId')}
                                         image={d.getAttribute('image')}/>, d);
        })


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
        reportWebVitals();
    }
}
